// src/lib/opportunity/requiredDocumentSlots.ts

import type { FormatDocumentSlotDef } from "./formatDocumentSlotTypes.js";

export type MissingRequiredDocumentSlot = {
  slot_key: string;
  label: string;
};

export function missingRequiredDocumentSlots(args: {
  slotDefs: FormatDocumentSlotDef[];
  documents: { category: string }[];
}): MissingRequiredDocumentSlot[] {
  const categoriesWithUpload = new Set<string>();
  for (const doc of args.documents) {
    categoriesWithUpload.add(doc.category);
  }

  return args.slotDefs
    .filter((slot) => slot.required_before_signed && !categoriesWithUpload.has(slot.slot_key))
    .map((slot) => ({ slot_key: slot.slot_key, label: slot.label }));
}

export function formatMissingRequiredDocumentSlotsError(
  missing: MissingRequiredDocumentSlot[],
): string {
  if (missing.length === 0) return "";
  const labels = missing.map((m) => m.label).join(", ");
  return `These documents are required before Signed: ${labels}. Upload on the Documents tab.`;
}
